import {Component, OnInit} from '@angular/core';
import {ListComponent, ItemComponent} from 'app/commons/list.component';
import {AppComponent} from 'app/app.component';
import {ConfirmationService, MessageService} from 'primeng/api';
import {RolesService} from './roles.service';
import {Router, ActivatedRoute} from '@angular/router';
import {AppBreadcrumbService} from '../app.breadcrumb.service';

@Component({
    selector: 'afm-roles',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export  class RolesComponent implements OnInit {

    title : string = 'Roles Management'
    
    constructor() {}

    ngOnInit() {
    }

}

@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class RoleListComponent extends ListComponent implements OnInit {

    constructor(private cs: ConfirmationService, private ms: MessageService,private s: RolesService, private a: AppComponent, private bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
    }

    ngOnInit() {
        super.ngOnInit()
        this.title = 'List of Roles';
        
    }
    getPath(){
        return 'role';
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px' },
            { field: 'name', header: 'Name',placeHolder:'' },
            { field: 'userCount', header: 'User Count',placeHolder:'' },
            { field: 'formCount', header: 'Form Count' ,placeHolder:''}
        ];
    }
}
@Component({
    templateUrl: './role.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class RoleComponent extends ItemComponent implements OnInit {
    
    users : any[] = [];

    constructor(private ms: MessageService, private s: RolesService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute, private bs: AppBreadcrumbService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit();
        this.s.getUsers().then(data => this.users = data);
    }
    
    getPath(){
        return 'roles';
    }
    getSuccessMessage(){
        return 'Role save with success';
    }
    getSelectedGroups(items : any[]) : string[]{
        return items ? items.map(item =>  item.name) : [];
    }

}

